<template>
  <div>
    <NotFoundData v-if="isEmptyData" />
    <div :style="{ visibility: isEmptyData ? 'collapse' : 'visible' }">
      <div class="contenedor-grafica"></div>
      <hr>
      <p class="text-dark w-100">
        Personaliza los filtros para cada gráfica, seleccionando las etiquetas de forma individual.
      </p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import * as echarts from "echarts";
import NotFoundData from "@/Aplicaciones/Masters/Areas/Prospecto/components/Graficas/NotFoundData.vue"

//import servicios from "../../../servicios/service.js";
const reporteActividades =
  "/api/Dashboard/Dashboard/ObtenerReportedeActividadesPorPersonalMaster";
const labelFormat = {
  color: "#000",
  fontSize: 14,
  fontWeight: "bold",
  show: true,
  position: "top", // Coloca la etiqueta de datos dentro de la barra
};

export default {
  components: {
    NotFoundData
  },
  name: "GraficaReporteActividades",
  props: [
    "masterId",
    "embajadorId",
    "sucursalId",
    "gerenciaId",
    "fechaInicio",
    "fechaFinal",
    "mostrarTodo"
  ],
  data() {
    return {
      dataActividades: []
    }
  },
  mounted() {
    this.reporteActividadesGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.mostrarTodo
    );
  },
  watch: {
    mostrarTodo() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaInicio() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaFinal() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    gerenciaId() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    sucursalId() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    embajadorId() {
      this.reporteActividadesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    }
  },
  methods: {
    async reporteActividadesGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          mostrarTodo
        }
      };
      try {
        const resp = await axios.get(reporteActividades, params);
        let miGraficaReporteActividades = echarts.dispose(
          document.querySelector(".contenedor-grafica")
        );
        miGraficaReporteActividades = echarts.init(
          document.querySelector(".contenedor-grafica")
        );
        const reporteActividadesData = resp.data.data;
        this.dataActividades = resp.data.data;
        const options = {
          textStyle: {
            fontFamily: "Poppins"
          },
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          tooltip: {
            trigger: "item"
          },
          grid: {
            left: "15%",
            right: "2%",
            bottom: "0%",
            top: '20%',
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              data: ["Valor"],
              show: false,
            }
          ],
          yAxis: [
            {
              type: "value",
              show: false,

            }
          ],
          legend: {
            show: true,
            orient: 'vertical', // Orientación vertical
            left: 'left', // Posición a la izquierda del gráfico
            top: '80px',
            icon: "circle",
            textStyle: {
              color: "black",
            },
            formatter: function (name) {
              // Reemplaza un espacio en blanco por "\n" para el salto de línea
              const formattedName = name.replace(' ', '\n');
              return formattedName;
            },
            itemWidth: 20, // Tamaño personalizado del ancho del marcador
            itemHeight: 20, // Tamaño personalizado de la altura del marcador
          },
          series: []
        };
        let validarExistenciaDatos = 0;
        let titulo = null;
        reporteActividadesData.map((element, index) => {
          options.series.push({
            name: element.nombreEtapa,
            type: "bar",
            label: labelFormat,
            stillShowZeroSum: false,
            data: [
              {
                value: element.valor,
              }
            ]
          });

          if (options.series[index].name === "CONTRATADO") options.series[index].color = "#65451F";
          if (options.series[index].name === "PAUSADO") options.series[index].color = "#9DC08B";
          if (options.series[index].name === "HOJA PRUEBA") options.series[index].color = "#5EAAA8";
          if (options.series[index].name === "VALIDAR PAGO") options.series[index].color = "#344D67";
          if (options.series[index].name === "PAGO DE CUOTA DE INSCRIPCIÓN") options.series[index].color = "#40513B";
          if (options.series[index].name === "GENERACIÓN INFORMACIÓN DE PAGO") options.series[index].color = "#BA704F";
          if (options.series[index].name === "INTEGRACIÓN DE EXPEDIENTE") options.series[index].color = "#4B778D";
          if (options.series[index].name === "ASESORÍA") options.series[index].color = "#609966";
          if (options.series[index].name === "PRIMER CONTACTO") options.series[index].color = "#C8AE7D";


          options.series[index].data[0].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
        });
        if (validarExistenciaDatos > 0) {
          titulo = "Reporte de actividades por personal";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaReporteActividades.setOption(options);
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    isEmptyData() {
      return (
        this.dataActividades.length === 0
      );
    }
  }
};
</script>
<style scoped>
.contenedor-grafica {
  border: 2px solid #cbcbcb;
  padding: 20px;
  min-height: 500px;
  margin: 20px 0;
}
</style>
